/* Mock Stern Grove "lineup2026" page. Mirrors the real customer's Squarespace
   markup (see ticketing-api-2.0/tmp/customer_code.html for the original code-injection
   block) so the editor can preview the Tixologi embed against the same DOM the
   embed targets in production: `.sqs-block-button-element` buttons whose text
   contains "lottery" plus a concert date phrase.

   The customer's pre-existing JotForm-based controller from customer_code.html is
   included verbatim in the page footer to simulate the real "before" state — the
   Tixologi embed loaded via {{EMBED_SCRIPT}} should override its behavior. */

const CONCERTS = [
	{ date: 'May 3', artist: 'Opening night' },
	{ date: 'May 10', artist: 'Concert 2' },
	{ date: 'May 17', artist: 'Concert 3' },
	{ date: 'May 24', artist: 'Concert 4' },
	{ date: 'May 31', artist: 'Concert 5' },
	{ date: 'June 7', artist: 'Concert 6' },
	{ date: 'June 14', artist: 'Concert 7' },
	{ date: 'June 21', artist: 'Concert 8' },
	{ date: 'June 28', artist: 'Concert 9' },
	{ date: 'July 4', artist: 'Concert 10' },
	{ date: 'July 5', artist: 'Closing night' },
];

const concertCards = CONCERTS.map(
	(c) => `
		<article class="concert-card">
			<h2>${c.date}</h2>
			<p>${c.artist}</p>
			<div class="sqs-block-button-container">
				<a class="sqs-button-element--primary sqs-block-button-element" href="#">
					Lottery Opens ${c.date}
				</a>
			</div>
		</article>`
).join('');

export const lineupDemoHtml = `<!doctype html>
<html lang="en">
	<head>
		<meta charset="UTF-8" />
		<title>Stern Grove Festival — 2026 Lineup (preview)</title>
		<style>
			:root { color-scheme: light; }
			body {
				margin: 0;
				font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
				background: #f7f5f0;
				color: #1d1d1d;
			}
			header {
				background: #1f4d3a;
				color: #f7f5f0;
				padding: 24px 32px;
			}
			header h1 { margin: 0; font-size: 22px; letter-spacing: 0.4px; }
			header p { margin: 4px 0 0; font-size: 13px; opacity: 0.85; }
			main {
				max-width: 920px;
				margin: 24px auto;
				padding: 0 16px;
				display: grid;
				grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
				gap: 16px;
			}
			.concert-card {
				background: #fff;
				border-radius: 8px;
				padding: 16px;
				box-shadow: 0 1px 2px rgba(0,0,0,0.06);
				display: flex;
				flex-direction: column;
				gap: 8px;
			}
			.concert-card h2 { margin: 0; font-size: 18px; }
			.concert-card p { margin: 0; font-size: 13px; color: #555; flex: 1; }
			.sqs-button-element--primary.sqs-block-button-element {
				display: inline-block;
				padding: 10px 14px;
				border: 2px solid #1f4d3a;
				background: #1f4d3a;
				color: #f7f5f0;
				font-size: 13px;
				text-align: center;
				text-decoration: none;
				border-radius: 4px;
				cursor: pointer;
				transition: background 120ms ease, color 120ms ease;
			}
			footer {
				text-align: center;
				padding: 24px;
				font-size: 12px;
				color: #888;
			}
		</style>
	</head>
	<body>
		<header>
			<h1>Stern Grove Festival</h1>
			<p>2026 Season — Lottery preview (mock page for embed testing)</p>
		</header>
		<main>${concertCards}
		</main>
		<footer>Mock page · partner 690 · simulating Squarespace lineup2026 markup</footer>

		<!-- Customer's pre-existing JotForm-based controller (from customer_code.html).
		     Bails out on non-lineup URLs (no-op in srcdoc), included for fidelity. -->
		<script>
			(function () {
				if (!window.location.pathname.includes("lineup2026-test")) return;
				// Original logic intentionally elided in this preview — the Tixologi embed
				// below should take over button behavior regardless.
			})();
		</script>

		<!-- Tixologi embed (the script being edited). -->
		<script>
			try {
				{{EMBED_SCRIPT}}
			} catch (e) {
				document.body.insertAdjacentHTML(
					'beforeend',
					'<pre style="color:#c0392b; padding:16px; white-space:pre-wrap;">' +
						(e && e.stack ? e.stack : e) + '</pre>'
				);
			}
		</script>
	</body>
</html>`;
